export interface CityEvent {
  id: string;
  title: string;
  category: 'Tech Expos' | 'Food & Music Fests' | 'Business Summits' | 'Cultural Shows' | 'Workshops';
  city: string;
  venue: string;
  date: string;
  time: string;
  price: string;
  image: string;
  description: string;
  organizer: string;
}

const CITY_EVENT_DATA: Record<string, CityEvent[]> = {
  'Chennai': [
    {
      id: 'evt-chn-1',
      title: 'Madras Food & Music Fiesta 2026',
      category: 'Food & Music Fests',
      city: 'Chennai',
      venue: 'ECR Beach Lawns, Besant Nagar',
      date: 'Sat, Aug 22, 2026',
      time: '04:00 PM - 10:30 PM',
      price: 'FREE ENTRY',
      image: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?auto=format&fit=crop&w=800&q=80',
      description: 'Experience South Indian culinary delights with live concerts featuring top indie bands in Chennai.',
      organizer: 'Chennai Cultural Club'
    },
    {
      id: 'evt-chn-2',
      title: 'Chennai AI & SaaS Tech Summit',
      category: 'Tech Expos',
      city: 'Chennai',
      venue: 'Chennai Trade Centre, Nandambakkam',
      date: 'Fri, Sep 04, 2026',
      time: '09:30 AM - 05:30 PM',
      price: '₹499 Early Bird',
      image: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=800&q=80',
      description: 'Annual gathering of SaaS founders, AI developers, and tech investors across Tamil Nadu.',
      organizer: 'NASSCOM Tamil Nadu Chapter'
    },
    {
      id: 'evt-chn-3',
      title: 'South India Startup Conclave',
      category: 'Business Summits',
      city: 'Chennai',
      venue: 'IIT Madras Research Park',
      date: 'Sat, Sep 12, 2026',
      time: '10:00 AM - 04:00 PM',
      price: 'FREE ENTRY',
      image: 'https://images.unsplash.com/photo-1475721027785-f74eccf877e2?auto=format&fit=crop&w=800&q=80',
      description: 'Network with VC investors, angel networks, and top 50 rising startups in South India.',
      organizer: 'IITM Incubation Cell'
    },
    {
      id: 'evt-chn-4',
      title: 'Margazhi & Carnatic Heritage Festival',
      category: 'Cultural Shows',
      city: 'Chennai',
      venue: 'Music Academy, Royapettah',
      date: 'Sun, Sep 20, 2026',
      time: '06:00 PM - 09:30 PM',
      price: '₹299 Ticket',
      image: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?auto=format&fit=crop&w=800&q=80',
      description: 'Mesmerizing classical Carnatic vocal & instrumental performances by renowned legends.',
      organizer: 'Madras Rasika Sabha'
    }
  ],
  'Mumbai': [
    {
      id: 'evt-mum-1',
      title: 'Mumbai Indie Music Carnival',
      category: 'Food & Music Fests',
      city: 'Mumbai',
      venue: 'Jio World Garden, BKC',
      date: 'Sat, Aug 29, 2026',
      time: '05:00 PM - 11:00 PM',
      price: '₹799 Entry',
      image: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?auto=format&fit=crop&w=800&q=80',
      description: 'India\'s premier outdoor music festival with artisan food stalls and live DJ sets.',
      organizer: 'Mumbai Live Events'
    },
    {
      id: 'evt-mum-2',
      title: 'Fintech & Web3 Leadership Forum',
      category: 'Tech Expos',
      city: 'Mumbai',
      venue: 'St. Regis Hotel, Lower Parel',
      date: 'Thu, Sep 10, 2026',
      time: '09:00 AM - 06:00 PM',
      price: '₹1,299 Delegate Pass',
      image: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=800&q=80',
      description: 'Connecting banking executives, fintech innovators, and regulatory authorities.',
      organizer: 'Fintech India Council'
    }
  ],
  'Bengaluru': [
    {
      id: 'evt-blr-1',
      title: 'Bengaluru Tech Expo & Hacker Con',
      category: 'Tech Expos',
      city: 'Bengaluru',
      venue: 'BIEC, Tumkur Road',
      date: 'Sat, Aug 22, 2026',
      time: '09:00 AM - 06:00 PM',
      price: 'FREE TICKET',
      image: 'https://images.unsplash.com/photo-1505373877841-8d25f7d46678?auto=format&fit=crop&w=800&q=80',
      description: 'Asia\'s largest technology exposition featuring AI, Cloud Robotics, and Open Source Summit.',
      organizer: 'Karnataka Digital Economy Mission'
    },
    {
      id: 'evt-blr-2',
      title: 'Nandi Hills Sunrise Cyclothon',
      category: 'Food & Music Fests',
      city: 'Bengaluru',
      venue: 'Nandi Hills Base Camp',
      date: 'Sun, Aug 30, 2026',
      time: '05:30 AM - 10:00 AM',
      price: 'FREE ENTRY',
      image: 'https://images.unsplash.com/photo-1517649763962-0c623266010b?auto=format&fit=crop&w=800&q=80',
      description: 'Community sunrise cycling event through scenic Nandi Foothills with breakfast provided.',
      organizer: 'Blr Cyclists Guild'
    }
  ]
};

export function getUpcomingEventsForCity(cityName: string): CityEvent[] {
  const cleanCity = cityName?.trim() || 'Chennai';
  // Return exact city match if available
  const matchKey = Object.keys(CITY_EVENT_DATA).find(k => k.toLowerCase() === cleanCity.toLowerCase());
  if (matchKey && CITY_EVENT_DATA[matchKey]) {
    return CITY_EVENT_DATA[matchKey];
  }

  // Auto Bot Event Generator for any new city!
  return [
    {
      id: `evt-auto-1-${cleanCity}`,
      title: `${cleanCity} Mega Business & Startup Expo 2026`,
      category: 'Business Summits',
      city: cleanCity,
      venue: `Central Convention Centre, ${cleanCity}`,
      date: 'Sat, Aug 29, 2026',
      time: '10:00 AM - 05:00 PM',
      price: 'FREE TICKET',
      image: 'https://images.unsplash.com/photo-1511578314322-379afb476865?auto=format&fit=crop&w=800&q=80',
      description: `Join 1,000+ business owners, entrepreneurs, and local leaders in ${cleanCity}.`,
      organizer: `${cleanCity} Chamber of Commerce`
    },
    {
      id: `evt-auto-2-${cleanCity}`,
      title: `${cleanCity} Live Music & Gourmet Food Carnival`,
      category: 'Food & Music Fests',
      city: cleanCity,
      venue: `City Exhibition Lawns, ${cleanCity}`,
      date: 'Sun, Sep 06, 2026',
      time: '04:00 PM - 10:00 PM',
      price: '₹199 Entry',
      image: 'https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?auto=format&fit=crop&w=800&q=80',
      description: `Delicious local cuisines and live acoustic musical performances for families in ${cleanCity}.`,
      organizer: `${cleanCity} Events Guild`
    },
    {
      id: `evt-auto-3-${cleanCity}`,
      title: `AI & Digital Growth Workshop ${cleanCity}`,
      category: 'Workshops',
      city: cleanCity,
      venue: `Tech Park Auditorium, ${cleanCity}`,
      date: 'Sat, Sep 19, 2026',
      time: '11:00 AM - 03:00 PM',
      price: 'FREE REGISTRATION',
      image: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=800&q=80',
      description: `Learn how to leverage AI tools and digital marketing to scale your enterprise in ${cleanCity}.`,
      organizer: 'Digital India Learning Hub'
    }
  ];
}
